const api_call = (topic) => {
  return (dispatch, getState) => {
    const data = JSON.stringify({ action: 'chat-topic-all', topic: topic });

    //window.sendWsMessage(data);
  };
};

export default api_call;
